import NetxQueryClient, {
	SuccessResponse,
} from '@netx/core-next/lib/queryClient';
export type {QueryError} from '@netx/core-next/lib/queryClient';
import {type ILabelValue} from '@netx/core-schema';
import {type ICategoryAutoListItem} from '../schema';

/**
 * `getCategoryAutoList` request params
 * (what is used to send to server)
 */
export interface GetCategoryAutoListRequestOptions {
	query: string;
	permissionMatrixLevel?: number;
}

/**
 * `getCategoryAutoList` request
 * (what gets sent to the server)
 */
export type GetCategoryAutoListRequest = [
	GetCategoryAutoListRequestOptions['query'],
	Required<GetCategoryAutoListRequestOptions>['permissionMatrixLevel'],
];

/**
 * `getCategoryAutoList` response
 * (what comes back from the server)
 */
export type GetCategoryAutoListResponse = SuccessResponse<ILabelValue[]>;

/**
 * `getCategoryAutoList` result
 * (what is utilized from the server response)
 */
export type GetCategoryAutoListResult = ICategoryAutoListItem[];

export const getCategoryAutoListEndpoint = 'getCategoryAutoList';

/**
 * Autolist categories
 * @param fetchParams Fetch params
 */
export const getCategoryAutoList = async (
	{query, permissionMatrixLevel = 1}: GetCategoryAutoListRequestOptions,
	signal?: AbortSignal,
) => {
	const client = NetxQueryClient();

	const requestParams: GetCategoryAutoListRequest = [
		query,
		permissionMatrixLevel,
	];

	return client
		.post<GetCategoryAutoListResponse>(
			getCategoryAutoListEndpoint,
			requestParams,
			{signal},
		)
		.then((response) =>
			response.data.result
				.map<ICategoryAutoListItem>((d) => ({
					...d,
					value: parseInt(d.value),
				}))
				.filter((d) => d.value !== 0),
		);
};
export default getCategoryAutoList;
